import { rgba } from 'polished'
import styled from 'styled-components'

import lottie from 'lottie-react-web'

export const Container = styled.form`
  flex: 1;
  width: 100%;
  max-width: 1300px;
  /* max-width: 1120px; */
  height: 100%;
  /* max-height: 100vh; */
  padding: 2rem 3rem;
  margin: auto;

  overflow: hidden auto;

  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0px;
    width: 100vw;
    height: inherit;

    background: url('/images/bgProject.svg') no-repeat top center;
    transform: translate(-51.5%, 0%);

    filter: blur(4px);
    opacity: 0.6;
    z-index: -1;
  }

  input {
    /* width: 100%; */
    height: 46px;
    padding: 1rem;

    border: 1px solid ${props => props.theme.colors.background.lighter};
    background: ${props => rgba(props.theme.colors.background.dark, 0.3)};
    border-radius: 6px;

    font-size: 1rem;

    &:focus {
      box-shadow: 0 10px 70px -20px ${props => rgba(props.theme.colors.primary.dark, 0.35)};
      border: 1px solid ${props => props.theme.colors.primary.normal};
    }
  }

  .button {
    width: 100%;
    max-width: 300px;
    height: 4rem;
    margin: 10px 0px 10px 0px;

    font-weight: 600;
    font-size: 1rem;

    background: linear-gradient(
      45deg,
      ${props => props.theme.colors.primary.normal},
      ${props => props.theme.colors.secondary} 100%
    );
  }

  header {
    height: 890px;

    display: grid;
    grid-template-columns: 600px auto;
    /* max-width: 1234px; */
    margin: 0px auto;
    padding: 0px 30px;
    position: relative;

    .title-box {
      width: 100%;
      height: 50%;

      margin-top: 6rem;

      display: grid;
      gap: 2rem;

      h1 {
        width: 100%;
        line-height: 10rem;
      }

      span {
        font-size: 2.6rem;
        font-weight: 600;
        overflow-wrap: break-word;

        color: ${props => props.theme.colors.text.title};
      }
    }
  }

  section {
    width: 100%;
    max-width: 1140px;
    min-height: 80vh;
    padding-top: 6rem;
    padding-bottom: 6rem;

    /* border-bottom: 1px solid ${props => props.theme.colors.tertiary}; */

    font-family: 'Poppins', sans-serif;
    line-height: 1.8rem;
    font-weight: 400;
    letter-spacing: 0.05rem;

    h2 {
      font-weight: 600;
      font-size: 6.2rem;
      line-height: 8rem;
      letter-spacing: -1px;
      padding-right: 0px;
      margin-bottom: 3.8rem;
    }

    h3 {
      margin: 2rem 0;
      font-size: 4.6rem;
      line-height: 5.2rem;
      font-weight: 500;
      text-transform: none;
    }

    & > div {
      width: 100%;

      display: flex;
      flex-wrap: wrap;
      column-gap: 2rem;
      row-gap: 2rem;

      &.checkboxes {
        width: 100%;
        .inputGroup {
          position: relative;
          min-width: 200px;
          width: fit-content;
          /* margin: 10px 0; */

          border: 1px solid ${props => props.theme.colors.background.lighter};
          border-radius: 6px;
          background: ${props => rgba(props.theme.colors.background.dark, 0.3)};

          label {
            position: relative;
            width: 100%;
            padding: 1rem;

            text-align: left;

            color: ${props => props.theme.colors.text.normal};

            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 1rem;

            cursor: pointer;
            z-index: 2;
            transition: color 200ms ease-in;
            overflow: hidden;

            &:after {
              content: '';
              width: 10px;
              height: 10px;

              border-radius: 50%;
              background-color: ${props => props.theme.colors.primary.normal};
              border-radius: 6px;

              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%) scale3d(1, 1, 1);
              transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);

              opacity: 0;
              z-index: -1;
            }

            &:before {
              content: '';
              width: 14px;
              height: 14px;
              /* padding: 0.4rem; */

              border: 2px solid
                ${props => props.theme.colors.background.lighter};
              background-color: transparent;
              border-radius: 50%;

              transition: all 200ms ease-in;
              cursor: pointer;
              z-index: 2;
            }
          }

          input:checked ~ label {
            color: #fff;
            border: 1px solid ${props => props.theme.colors.primary.normal};
            border-radius: 6px;
            box-shadow: 0 4px 20px -10px ${props => rgba(props.theme.colors.primary.normal, 0.6)};

            &:after {
              transform: translate(-50%, -50%) scale3d(56, 56, 1);
              opacity: 1;
            }

            &:before {
              background-image: radial-gradient(
                circle 8px,
                ${props => props.theme.colors.background.lighter} 50%,
                ${props => props.theme.colors.background.lighter} 50%,
                ${props => props.theme.colors.primary.normal} 60%
              );
            }
          }

          input {
            width: 32px;
            height: 32px;
            order: 1;
            z-index: 2;
            position: absolute;
            right: 30px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            visibility: hidden;
          }
        }
      }
    }

    &.personal-data {
      /* input + input {
        margin-top: 2rem;
      } */
    }
  }

  @media only screen and (max-width: 1200px) {
    padding: 40px;
  }

  @media only screen and (max-width: 768px) {
    padding: 30px 20px;

    header {
      grid-template-columns: 360px auto;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 0rem 2rem;

    header {
      height: 100vh;

      padding: 0;
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;

      h1 {
        font-size: 4.3rem;
        line-height: 4.3rem;
        letter-spacing: -2px;
      }
      .title-box span {
        font-size: 1.8rem;
        font-weight: 500;
        line-height: 130%;
      }
    }

    section {
      & > div {
        input {
          width: 100%;
        }

        &.checkboxes {
          .inputGroup {
            width: 100%;
          }
        }
      }
      h2 {
        font-weight: 600;
        font-size: 50px;
        line-height: 55px;
        letter-spacing: -1px;
        padding-right: 0px;
        margin-bottom: 50px;
      }

      h3 {
        font-size: 40px;
        line-height: 45px;
        letter-spacing: 0px;
      }
      span,
      p {
        font-size: 16px;
        line-height: 26px;
      }
    }
  }
`

export const Lottie = styled(lottie).attrs(() => ({
  style: {
    position: 'absolute',
    width: '4rem',
    height: 'auto',
    marginTop: '0%',

    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 5

    // filter: 'opacity(0.5) invert(1) grayscale(1) brightness(0.3)'
  }
}))``
